import script from "./TriggerChip.vue?vue&type=script&setup=true&lang=js"
export * from "./TriggerChip.vue?vue&type=script&setup=true&lang=js"

import "./TriggerChip.vue?vue&type=style&index=0&id=1ffc62eb&lang=css"

const __exports__ = script;

export default __exports__